// Skip and suppression codes stored in email_campaign_recipients.error and
// returned by the audience preview, mapped to plain wording. One source for
// the campaign report, the recipients drawer, and the CSV exports.
export const REASON_LABELS: Record<string, string> = {
  suppressed_prior_bounce: 'Previously bounced',
  suppressed_complaint: 'Previously marked as spam',
  suppressed_invalid_address: 'Invalid address',
  suppressed_disposable_domain: 'Disposable email address',
  suppressed_no_mx: 'Domain cannot receive mail',
  opted_out: 'Opted out of marketing email',
  campaign_cancelled: 'Campaign cancelled',
  auto_paused_high_bounce_rate: 'Stopped by the reputation guard',
  template_missing: 'Template missing',
  company_context_missing: 'Company details missing'
}

export const SUPPRESSION_CODES = Object.keys(REASON_LABELS).filter((code) => code.startsWith('suppressed_'))

// Anything not listed (renderer failure text) renders as is.
export function reasonLabel(code: string | null | undefined): string {
  if (!code) return '-'
  return REASON_LABELS[code] || code
}
